// Typy liczników z WS/REST ("counters"). Wartości MUSZĄ odpowiadać
// Kwantum.LegalMail.Core.Enums.UserCounterType po stronie backendu.
export enum ECounterType {
  RemovedIncoming = 0,
  RemovedOutgoing = 1,
  RemovedTasks = 2,
  RemovedCases = 3,
  RemovedClient = 4,

  UnreadIncoming = 10,
  UnreadOutgoing = 11,
  UnreadTasks = 12,
  UnreadCases = 13,
  UnreadClient = 14,
  UnreadDrive = 15,
  UnreadShares = 16,

  DeskCases = 20,
  DeskIncoming = 21,
  DeskOutgoing = 22,
  DeskTasks = 23,
  DeskEvents = 24,
  DeskDriveItems = 25,
  DeskDriveFolders = 26,

  UnreadIncomingEDelivery = 27,
  UnreadChats = 28,

  ListFilter = 98,

  // Suma wszystkich liczników ze wszystkich profili użytkownika.
  Total = 100,

  AdminLegalPersonRequests = 999,
}
